import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_VEHICLE_MODELS](state, data) {
    state.allVehicleModels = data
  },
  [types.SAVE_VEHICLE_MODEL](state, data) {
    state.allVehicleModels.push(data)
  },
}
